// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ski-email-security-controls.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ski-email-security-controls',
  title: 'Enforce email security controls for customer data transmission',
  description:
    'When email is used to transmit customer data, the following controls must be in place: only approved organisational email accounts may be used (not personal accounts); email servers must enforce encryption meeting CFCS (Danish Centre for Cyber Security) minimum requirements; all inbound and outbound email must be scanned for malicious code and blocked if detected.',
  category: 'technical',
  scfIds: ['SCF-NET-005', 'SCF-OPS-003'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Email security standard for customer data transmission is published',
    },
    { type: 'document-within-sla', description: 'Standard review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
